import { useAuthStore } from '../../stores/auth.store';
import { QueryClient } from '@tanstack/react-query';

interface ClearAuthOptions {
  redirect?: boolean;
  logout?: (options: any) => void;
  queryClient?: QueryClient;
  redirectPage?: string;
}

export const clearAuthAndCache = async ({
  redirect = true,
  logout,
  queryClient,
  redirectPage = '',
}: ClearAuthOptions = {}) => {
  const clearUser = useAuthStore.getState().clearUser;

  // Clear all React Query caches if queryClient is provided
  if (queryClient) {
    await queryClient.clear();
  }

  // Clear user from Zustand store
  clearUser();

  // Clear local storage
  localStorage.removeItem('auth0.is.authenticated');
  localStorage.removeItem('auth0.application.client_id');
  sessionStorage.removeItem('auth0.is.authenticated');
  sessionStorage.removeItem('auth0.application.client_id');

  // Logout from Auth0 if logout function is provided
  if (logout) {
    if (redirect) {
      logout({
        logoutParams: {
          returnTo: window.location.origin + redirectPage,
        },
      });
    } else {
      // Just clear the auth state without redirecting
      logout({
        logoutParams: {
          returnTo: window.location.origin + redirectPage,
          skipRedirect: true,
        },
      });
    }
  }
};
